blockVideoHandler = {
    $btnDropDown = $('.btn-drop-down'),

    resizeVideoThumbnails = function() {
		$('.video-container').each(function() {
			var $video = $(this);
			var widthVid = parseFloat($video.width());
			var heightVid = parseFloat($video.height());
			var newHeight = (widthVid * 9) / 16 ; 
			if (heightVid != newHeight) {
				$video.css({
					'min-height': Math.round(newHeight)+"px",
				});	
			}
            var $iframe = $video.find('iframe');
            if ($iframe.length > 0) {
                if (!$iframe.attr('src').includes('autoplay')) {
                    $iframe[0].src += "?autoplay=1";
                }
            }
            
		});
	},

    init = function(){
        var self = this;

        
        $(window).on('resize', function() {
            self.resizeVideoThumbnails();
        }).trigger('resize');

        $(window).on('load', function() {
            self.resizeVideoThumbnails();
        });

        this.$btnDropDown.on('click', function(e){
            e.stopPropagation();
            var $obj   = $(this);
            var height = $obj.outerHeight();
            var $itemDropDown = $obj.next();
            var heightPanel = 0;
            $obj.toggleClass('active');
            $itemDropDown.toggleClass('active');

            if ($itemDropDown.hasClass('active') === true) {
                $itemDropDown.children().each(function(){
                    heightPanel += $(this).outerHeight();
                });
            }   
            
            $itemDropDown.css({
                'top': height+'px',
                'height': heightPanel+'px'
            });
            
        });
        $('body').on("click", function(e) {
            $btnDropDown.filter('.active').trigger('click');
        });
    }
}